import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
  SortableElement,
} from 'react-sortable-hoc';

// Components
import { DeleteIcon, EditIcon } from '@zola/zola-ui';
import DragHandle from '../../../../../common/ui/DragHandle';

const EditPageSortableItem = SortableElement(({
  entity,
  onEdit,
  onDelete,
  entityDetail,
  entityType,
}) => {
  const noPropagate = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  return (
    <li className={`edit-page entity-item edit-page-entity-item entity-item--${entityType}`} onClick={() => onEdit(entity)}>
      <DragHandle />
      <div className="entity-details">
        {entityDetail(entity)}
      </div>
      <div className="entity-actions" onClick={noPropagate}>
        {onEdit && (
          <button
            onClick={() => onEdit(entity)}
            title="Edit Registry"
            className="edit-btn btn-icon with-tooltip no-tooltip-on-mobile"
            data-tooltip="Edit"
            type="button"
          >
            <EditIcon />
          </button>
        )}
        {onDelete && (
          <button
            onClick={() => onDelete(entity)}
            title="Delete Registry"
            className="delete-btn btn-icon with-tooltip no-tooltip-on-mobile"
            data-tooltip="Delete"
            type="button"
          >
            <DeleteIcon />
          </button>
        )}
      </div>
    </li>
  );
});

export const EntityName = ({children, name, addClass}) => {
  const classNames = cx('entity-name', { [`${addClass}`]: addClass });
  return (
    <h4 className={classNames}>{name || children}</h4>
  )
}

export const EntityType = ({children, type, addClass}) => {
  const classNames = cx('entity-type', { [`${addClass}`]: addClass });
  return (
    <div className={classNames}>{type || children}</div>
  )
}

export const EntityDesciption = ({children, description, addClass}) => {
  const classNames = cx('entity-description', { [`${addClass}`]: addClass });
  return (
    <div className={classNames}>{description || children}</div>
  )
}

EditPageSortableItem.propTypes = {
  entity: PropTypes.shape({}),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  entityDetail: PropTypes.func,
  entityType: PropTypes.string,
};

export default EditPageSortableItem;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/EditPageCommon/EditPageSortableList/EditPageSortableItem.jsx